
import { useEffect } from "react";
export default function useGlobalGaClickTracking() {
  useEffect(() => {
    // Prevent double-attach in React StrictMode or multiple component mounts
    if (window.__gaClickTrackerAttached) return;
    window.__gaClickTrackerAttached = true;

    let lastKey = "";
    let lastTime = 0;
    const USE_CAPTURE = true;

    const handler = (e) => {
      if (typeof window.gtag !== "function") return;
      if (e.button !== 0) return;

      const target = e.target?.closest?.(
        "button, a, [role='button'], input[type='button'], input[type='submit']"
      );
      if (!target) return;

      if (target.getAttribute("data-ga-ignore") === "true") return;

      const name = (
        target.getAttribute("data-ga-name") ||
        target.getAttribute("aria-label") ||
        target.innerText ||
        target.value ||
        "unknown"
      )
        .trim()
        .slice(0, 120);

      const type =
        target.getAttribute("data-ga-type") ||
        (target.tagName === "A" ? "link" : target.type || "click");

      const id = target.id || "no-id";
      const cls =
        typeof target.className === "string"
          ? target.className.trim().slice(0, 200)
          : "no-class";

      const key = `${name}|${type}|${id}|${window.location.pathname}`;
      const now = Date.now();
      if (key === lastKey && now - lastTime < 400) {
        return;
      }
      lastKey = key;
      lastTime = now;

      window.gtag("event", "button_click", {
        button_name: name,
        button_type: type,
        button_id: id,
        button_class: cls || "no-class",
        page_location: window.location.href,
      });
      if (window._satellite?.track) {
        window._satellite.track("button_click");
      }
    };

    document.addEventListener("click", handler, USE_CAPTURE);

    return () => {
      document.removeEventListener("click", handler, USE_CAPTURE);
      window.__gaClickTrackerAttached = false;
    };
  }, []);
}